<template>
	<Body class="page-auth-profile thankyou-page" />
	<BaseCmsPage v-slot="{page}">
		<BaseWebshopCheckout v-slot="{user}">
			<CmsIntroContainer :page="page" mode="webshop">
				<template #h1>
					<h1 v-if="page?.seo_h1">{{ page.seo_h1 }}<template v-if="user?.first_name"> {{user.first_name}}</template></h1>
				</template>
			</CmsIntroContainer>

			<ClientOnly>
				<BaseWebshopOrder v-slot="{order, shipping, termsPdf, invoicePdf, paymentTransferUrl}">
				<section class="main">
					<div class="wider-wrapper">
						<div class="main-content">
							<div class="checkout-cnt" v-if="order">
								<div v-if="page?.content" v-html="page.content" v-interpolation />

								<p>
									<a :href="termsPdf" target="_blank" v-if="termsPdf" class="btn btn-primary btn-download btn-download-pdf btn-download-terms">
										<BaseCmsLabel code="thank_you_download_terms_pdf" tag="span" />
									</a>
								</p>

								<div class="invoice-container">
									<p><BaseCmsLabel code="choosen_shipping" /> "<strong>{{ shipping?.title }}</strong>".<br><BaseCmsLabel code="order_email" /> <strong>{{order?.customer?.email}}</strong>.</p>
									
									<p v-if="invoicePdf">
										<a :href="invoicePdf" target="_blank" class="btn btn-primary btn-download btn-download-pdf btn-download-terms"><span class="icon icon-pdf"><BaseCmsLabel :code="order?.cart?.payment_transfer_data ? 'order_download_invoice_payment' : 'order_download_invoice'" /></span></a>
									</p>
								</div>

								<template v-if="order?.cart?.payment_transfer_data">
									<BaseWebshopPaymentTransfer :data="order.cart.payment_transfer_data" />

									<p><a :href="paymentTransferUrl+'&mode=pdf'" target="_blank" class="btn btn-print"><BaseCmsLabel code="print_payment" tag="span" /></a></p>
								</template>
							</div>
						</div>
						<CmsSidebar />
					</div>
				</section>
				</BaseWebshopOrder>
				<template #fallback>
					<BaseThemeUiLoading />
				</template>
			</ClientOnly>
		</BaseWebshopCheckout>
	</BaseCmsPage>
</template>


<script setup>
</script>

<style lang="less" scoped>
</style>
